import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { DataCafService } from 'src/app/services/data-caf.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { NotaCreditoCabeceraFTComponent } from './nota-credito-cabecera/nota-credito-cabecera.component';
import { NotaCreditoDetallesFTComponent } from './nota-credito-detalles/nota-credito-detalles.component';

@Component({
  selector: 'app-nota-credito',
  templateUrl: './nota-credito.component.html',
  styleUrls: ['./nota-credito.component.scss'],
  providers: [SecurityService],
})
export class NotaCreditoFTComponent implements OnInit {
  // Modales
  @ViewChild(NotaCreditoCabeceraFTComponent, { static: true }) cabeceraComponent: NotaCreditoCabeceraFTComponent;
  @ViewChild(NotaCreditoDetallesFTComponent, { static: true }) detallesComponent: NotaCreditoDetallesFTComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // optionsBodega: Array<any> = [];
  // optionsCondPago: Array<any> = [];
  // optionsListaPrecio: Array<any> = [];
  // optionsMedida: Array<any> = [];
  // optionsCategoria: Array<any> = [];
  // optionsFamilia: Array<any> = [];
  // optionsTipoTraslado: Array<any> = [];
  // optionsTipoEnvio: Array<any> = [];
  // dataCabecera: any = null
  // dataFooter: any = null

  processing: boolean = false;

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  // Utils
  private log: any;
  codigos_dte: number[];

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private dataCafService: DataCafService
  ) {
    this.log = this.clog.log('NOTA-CREDITO');

    // Seteamos los codigos DTE
    this.codigos_dte = [61];
    // Seteamos el valor del codigo DTE
    this.dataCafService.setDataCodigoDTE(61);
  }

  ngOnInit() {}

  public handleCabeceraChange(dataCabecera) {
    // this.dataCabecera = dataCabecera
    // this.detallesComponent.handleCabeceraChange(this.dataCabecera)
    this.detallesComponent.handleCabeceraChange(dataCabecera);
  }

  beginSave() {
    this.GuardarNotaCredito();
  }

  //Guardar Nota de Crédito
  GuardarNotaCredito() {
    const isHeaderValid = this.cabeceraComponent.validate();
    if (!isHeaderValid) {
      this.toastrService.warning('Complete la información requerida');
      return;
    }

    const headerData = this.cabeceraComponent.getHeaderData();
    const { dataCabecera, tipoNotaCredito, tipoCorreccionMonto, rebajaStock, tipoAplicacion, fechaDocumento } = headerData;
    this.log('headerData', headerData);
    if (!dataCabecera) {
      this.toastrService.warning('Complete la información requerida');
      return;
    }

    const { cabecera: cabeceraOrigen, descuentosGlobales } = dataCabecera;
    // const { additionalInfo } = cabeceraOrigen

    const detailsData = this.detallesComponent.getDetailsData();
    const { observaciones, glosa_administrativa, motivoGeneral, detalleDocumento: detalleDocumentoOrigen } = detailsData;

    const sendDctosGlobales = (tipoNotaCredito === 2 && tipoCorreccionMonto === 10) || tipoNotaCredito === 3;
    this.log('sendDctosGlobales', sendDctosGlobales);

    const folio = cabeceraOrigen.folio;
    const fecha_emision = cabeceraOrigen.fecha_emision;

    // Clone objects
    let cabecera = _.cloneDeep(cabeceraOrigen);
    let detalleDocumento = _.cloneDeep(detalleDocumentoOrigen);

    const esCorreccionDeMonto = cabecera.additionalInfo.esCorreccionDeMonto;

    // Clear detalle
    detalleDocumento.map((detalle) => {
      // delete detalle.additionalInfo // Lo eliminaré más abajo ya que lo necesito para unas validaciones
      if (detalle.atributos)
        detalle.atributos.map((attr) => {
          delete attr.__typename;
        });
    });

    // Clear cabecera
    delete cabecera.additionalInfo;
    delete cabecera.cliente_nombre;
    delete cabecera.direccion_nombre;
    delete cabecera.folio;
    delete cabecera.tipo_devolucion_codigo;
    delete cabecera.tipo_envio_codigo;
    delete cabecera.tipo_traslado_codigo;
    delete cabecera.vendedor_nombre;

    // Set data
    cabecera.observaciones = observaciones;

    cabecera.tipo_ncnd_codigo = tipoNotaCredito;

    const inputParams: any = {
      entidadReferencia: {
        rut_emisor: cabecera.rut_emisor,
        tipo_dte_codigo: cabecera.tipo_dte_codigo,
        folio, //: Number(headerData.nroDoc), // cabecera.folio
        fecha_emision,
      },
      entidad: {
        cabecera,
        descuentosGlobales: [],
        detalleDocumento,
      },
    };

    // Set defaults
    inputParams.entidad.cabecera.fecha_emision = fechaDocumento;
    inputParams.entidad.cabecera.glosa_administrativa = '';
    inputParams.entidad.cabecera.motivo_devolucion_codigo = 0;
    inputParams.entidad.cabecera.aplica_rebaja = false;
    inputParams.entidad.cabecera.es_correcion_monto = false;

    // ADMINISTRATIVA
    if (tipoNotaCredito === 1) {
      inputParams.entidad.detalleDocumento = [];
      inputParams.entidad.cabecera.glosa_administrativa = glosa_administrativa;
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
      if (!this.validateAndHandleGlosaAdministativa(glosa_administrativa)) return;

      if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) return false;
    }
    // POR CORRECCIÓN DE MONTO
    else if (tipoNotaCredito === 2) {
      this.log('tipoCorreccionMonto', tipoCorreccionMonto);

      inputParams.entidad.cabecera.aplica_nota_credito = tipoAplicacion === 1;
      inputParams.entidad.cabecera.es_correcion_monto = esCorreccionDeMonto;

      // DEVOLUCION
      if (tipoCorreccionMonto === 10) {
        if (!this.validateAndHandleDetalles(detalleDocumento)) return false;
        inputParams.entidad.cabecera.aplica_rebaja = rebajaStock;
        inputParams.entidad.descuentosGlobales = descuentosGlobales;
        inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
        if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) return false;
      }
      // CORRECCION MONTO
      if (tipoCorreccionMonto === 20) {
        if (!this.validateAndHandleDetalles(detalleDocumento, false)) return false;
        inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
        if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) return false;
      }
    }
    // POR ANULACION
    else if (tipoNotaCredito === 3) {
      if (!this.validateAndHandleDetalles(detalleDocumento, false)) return false;

      inputParams.entidad.cabecera.aplica_nota_credito = tipoAplicacion === 1;
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
      if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) return false;
      inputParams.entidad.cabecera.aplica_rebaja = rebajaStock;
      inputParams.entidad.descuentosGlobales = descuentosGlobales;
    }

    // Validar motivo general en base a si está mostrado en pantalla
    if (dataCabecera.cabecera.additionalInfo.showMotivoGeneral) if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) return false;

    // Lo elimino acá. Clear detalle->additionalInfo
    detalleDocumento.map((detalle) => {
      delete detalle.additionalInfo; // Lo eliminaré más abajo ya que lo necesito para unas validaciones
    });

    this.log('inputParams', JSON.stringify(inputParams));
    this.log('inputParams', inputParams);

    this.processing = true;

    if (dataCabecera.cabecera.tipo_dte_codigo == 46) {
      this.mutationGuardarNotaCreditoFT(inputParams, ({ mensajes, respuesta }) => {
        const hayErrores = mensajes && mensajes.length > 0 && mensajes.some((m) => m.tipo === 'ERROR');
        if (hayErrores) {
          this.messageRendererService.showErrors(mensajes);
          this.processing = false;
          return;
        }
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.processing = false;
          return;
        }

        const { folio } = respuesta.cabecera;
        this.toastrService.success(`Nota crédito guardada con folio ${folio}`);
        this.processing = false;
        this.CleanData();

        this.contadorFacturas++;

        return;
      });
    } else {
      this.mutationGuardarNotaCredito(inputParams, ({ mensajes, respuesta }) => {
        const hayErrores = mensajes && mensajes.length > 0 && mensajes.some((m) => m.tipo === 'ERROR');
        if (hayErrores) {
          this.messageRendererService.showErrors(mensajes);
          this.processing = false;
          return;
        }
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.processing = false;
          return;
        }

        const { folio } = respuesta.cabecera;
        this.toastrService.success(`Nota crédito guardada con folio ${folio}`);
        this.processing = false;
        this.CleanData();

        this.contadorFacturas++;

        return;
      });
    }
  }

  private CleanData() {
    this.cabeceraComponent.cleanData();
    this.detallesComponent.cleanData();
  }

  private validateAndHandleGlosaAdministativa(glosa) {
    if (!glosa || glosa.length === 0) {
      this.toastrService.warning('Ingrese glosa');
      return false;
    }
    return true;
  }

  private validateAndHandleDetalles(detalles, validateMotivo: boolean = true) {
    if (!detalles || detalles.length === 0) {
      this.toastrService.warning('Ingrese detalle');
      return false;
    }

    // cantidades
    for (let i = 0; i < detalles.length; i++) {
      if (Number(detalles[i].cantidad) > Number(detalles[i].additionalInfo.cantidad)) {
        this.toastrService.warning('Existe una cantidad no válida');
        return false;
      }
    }

    if (validateMotivo) {
      // for (let i = 0; i < detalles.length; i++) {
      //   if (!detalles[i].motivo_devolucion_especifico_codigo || detalles[i].motivo_devolucion_especifico_codigo === 0) {
      //     this.toastrService.warning('Ingrese motivo devolución específico')
      //     return false
      //   }
      // }
      const notValids = detalles.filter((detalle) => !detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0);
      if (notValids.length === detalles.length) {
        this.toastrService.warning('Ingrese al menos un motivo de devolución específico');
        return false;
      }
    }

    // detalles.map(detalle => {
    //   if (!detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0) {
    //     this.toastrService.warning('Ingrese motivo devolución específico')
    //     return false
    //   }
    // });
    return true;
  }

  private validateAndHandleMotivoGeneral(motivoGeneral) {
    this.log('validateAndHandleMotivoGeneral', motivoGeneral);
    if (!motivoGeneral || motivoGeneral === 0 || motivoGeneral === '0') {
      this.toastrService.warning('Ingrese motivo devolución general');
      return false;
    }
    return true;
  }

  private mutationGuardarNotaCredito(inputParams, callback) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
            documento {
              guardarNotaCredito(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaCredito;
        callback({ mensajes, respuesta });
      }
    );
  }

  private mutationGuardarNotaCreditoFT(inputParams, callback) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
            documento {
              guardarNotaCreditoFT(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaCreditoFT;
        callback({ mensajes, respuesta });
      }
    );
  }

  clearFromButton() {
    this.modalConfirm.show(() => {
      this.CleanData();
    });
  }

  onDetalleDocumentoChange(registros) {
    this.cabeceraComponent.updateDetalleDocumento(registros);
  }
}
